import React from "react";
import { Link } from "react-router-dom";
import BTableCell from "./BTableCell";

export default function BTableCellWithLink({to, cell}) {
  return (
    <Link to={to}>
      <BTableCell cell={cell} />
    </Link>
  );
}
